import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const scrollToPurchase = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (props.onClick) props.onClick(e);
    const element = document.getElementById('comprar');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={scrollToPurchase} className={`
        inline-flex items-center justify-center rounded-lg font-bold transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 px-6 py-3
        ${fullWidth ? 'w-full' : ''}
        ${variant === 'primary' ? 'bg-[#d4a853] text-[#1e3a5a] hover:bg-[#c49843] shadow-lg border-b-4 border-[#b48833] active:border-b-0 active:translate-y-1 focus:ring-[#d4a853]' : 'bg-[#1e3a5a] text-white hover:bg-[#2c4b6e] shadow-md focus:ring-[#1e3a5a]'}
        ${className || ''}
      `} {...props} data-id="element-367">
      {children}
    </button>;
}